import { Inject } from 'inversify-props'
import { EventosServiceAdapter } from './EventosServiceAdapter'
import { AxiosRequestConfig } from 'axios'
import { Page } from '@/models'
import { Eventos } from '@/models/Eventos'


export class FindEventoUseCase {

	@Inject('EventoServiceAdapter')
	private eventosService!: EventosServiceAdapter

	findAll = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Eventos>> =>
		await this.eventosService.findAll(params, config)

}